
import React from 'react'

import { getErrorMessage } from 'utils'

import type { Product } from 'types'

import { useSnackbar } from 'contexts'
import { useProductMutations } from 'hooks/api'

import { useTheme, Stack, Typography } from '@mui/material'

import { Modal } from '@repo/ui'
import { Button } from '@repo/ui'
import {ProductPreview } from 'components'







interface ProductWithCertificatesCount extends Product {
  certificates_count: number
}

interface DeleteProductModalProps {
  product: ProductWithCertificatesCount | null
  open: boolean
  onClose: () => void
  refetch: () => void
  /** Called after a successful delete instead of refetch — e.g. the detail page
   *  navigates back to the products list (the deleted product no longer exists). */
  onDeleted?: () => void
}

export const DeleteProductModal = (props: DeleteProductModalProps) => {
  const { product, open, onClose = () => {}, refetch, onDeleted } = props
  const theme = useTheme()

  const { open: notification } = useSnackbar()

  const [{ remove }, { isLoading }] = useProductMutations({
    onSuccess: () => {
      handleClose()
      if (onDeleted) {
        onDeleted()
      } else {
        refetch()
      }
    },
    onError: error => {
      const message = getErrorMessage(error)
      const isCertBlock = /linked certificate/i.test(message)
      notification({
        type: 'error',
        title: message,
        ...(isCertBlock
          ? { text: 'Archive it instead to hide it from your list.' }
          : {}),
      })
    },
  })

  const handleDeleteProduct = () => {
    if (!product) return
    const hasCertificate = product.certificates_count !== 0

    if (hasCertificate) {
      const count = product.certificates_count
      const plural = count === 1 ? 'certificate' : 'certificates'
      return notification({
        type: 'error',
        title: `This product has ${count} linked ${plural} and can't be deleted.`,
        text: 'Archive it instead to hide it from your list.',
      })
    }
    remove({ id: product!.id })
  }

  const handleClose = () => {
    onClose()
  }


  return (
    <Modal
      title="Delete product"
      open={open}
      onClose={handleClose}
      actions={
        <>
          <Button
            disableElevation
            variant="secondary"
            onClick={() => handleClose()}
          >
            Cancel
          </Button>

          <Button
            disableElevation
            destructive
            onClick={() => handleDeleteProduct()}
          >
            Delete
          </Button>
        </>
      }
    >
      <Stack spacing={4}>
        <Typography variant="body2" color="text.secondary">Are you sure you want to delete the following product?</Typography>
        <ProductPreview product={product} />
      </Stack>
    </Modal>
  )
}
